var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasLink && _vm.isExternal)?_c('a',{staticClass:"tag",attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.text))]):(_vm.hasLink && !_vm.isExternal)?_c('nuxt-link',{staticClass:"tag",attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.text))]):_c('span',{staticClass:"tag"},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }